var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUploadSmall(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_18224_13312)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.66634 10.6684H9.33301C9.69967 10.6684 9.99967 10.3684 9.99967 10.0018V6.66844H11.0597C11.653 6.66844 11.953 5.94844 11.533 5.52844L8.47301 2.46844C8.21301 2.20844 7.79301 2.20844 7.53301 2.46844L4.47301 5.52844C4.05301 5.94844 4.34634 6.66844 4.93967 6.66844H5.99967V10.0018C5.99967 10.3684 6.29967 10.6684 6.66634 10.6684ZM3.99967 12.0018H11.9997C12.3663 12.0018 12.6663 12.3018 12.6663 12.6684C12.6663 13.0351 12.3663 13.3351 11.9997 13.3351H3.99967C3.63301 13.3351 3.33301 13.0351 3.33301 12.6684C3.33301 12.3018 3.63301 12.0018 3.99967 12.0018Z",
    fill: "#303f47"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_18224_13312"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadSmall);
export default __webpack_public_path__ + "static/media/upload-small.51267f3aa76d5114a634bbc60e39b29d.svg";
export { ForwardRef as ReactComponent };